import React from 'react';
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';
import { getTokens } from './theme/index.js';
import { ScopedVariables } from './theme/scoped-variables.styles.js';
export const ThemeProvider = ({ children, theme }) => (React.createElement(StyledComponentsThemeProvider, { theme: { ...theme, ...getTokens(theme?.name) } },
    React.createElement(ScopedVariables, null, children)));
//# sourceMappingURL=index.js.map